import { Grid, Paper } from "@mui/material"

export default function Panel({ children, ...props }) {
  return (
    <Grid {...props}>
      <Paper>
        {children}
      </Paper>
    </Grid>
  )
}
